import { Component, HostListener } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LoadingService } from './services/loading.service';
import { UtilityService } from './services/utility.service';
import { MatIconRegistry } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { page } from './util/animations.util';
import { RouterOutlet } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from './services/user.service';
import { HttpClient } from '@angular/common/http';
import { AndroidBridgeService } from './services/android-bridge-service';

// declare const $: any;
// console.dir($)

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    page
  ]
})
export class AppComponent {
  // isLoading = false;
  isOnline: boolean = false;
  private iconPath: string = "assets/img/";

  current_time!: number;
  expired_time!: number;
  load_expired_dialog_time!: number;
  decode: any;
  token!: string;
  timer: any;

  isOldTab = false;

  constructor(
    public loadingService: LoadingService,
    private utilityService: UtilityService,
    private icon: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    private dialog: MatDialog,
    private userService: UserService,
    private androidBride: AndroidBridgeService

  ) {
    this.utilityService.getNetworkChangeObservable().subscribe(x => {
      this.isOnline = x;
    });
    this.addIcons();

    this.userService.logOutEventEmitter.subscribe(res => {
      clearTimeout(this.timer);
      this.dialog.closeAll();
    })
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
    this.androidBride.unload();
  }


  ngOnInit(): void {
    const lang = this.utilityService.getLang();

    this.translate.setDefaultLang('en');

    if (!navigator.onLine) {
      console.warn('Offline mode — skip language reload');
      return;
    }

    this.translate.use(lang).subscribe({
      error: (err) => {
        console.error('Translation load failed:', err);

        if (err.status === 0) {
          console.warn('Network lost while loading language');
        }

        this.translate.use('en');
      }
    });
  }

  get isLoading(): boolean {
    return this.loadingService.isLoading;
  }

  addIcons(): void {
    this.addIcon("day_card", "CompositeLayer");
    this.addIcon("document_page_number", "document-page-number");
    this.addIcon("event", "event");
    this.addIcon('invoice', 'invoice');
    this.addIcon("day_card", 'day-card');
    this.addIcon("day_card_active", 'day-card-active');
    this.addIcon("paper", "paper");
    this.addIcon("edit", "edit");
    this.addIcon("ref", "ref");
    this.addIcon("ticket_type", "ticket-type");
    this.addIcon("hand", "hand");
    this.addIcon("coin", "coin-stack");
    this.addIcon("date", "date");
    this.addIcon("visitor_color", "visitor-color");
    this.addIcon("order", "order");
    this.addIcon("paid_order", "paid-order");
    this.addIcon("unpaid_order", "unpaid-order");
    this.addIcon("inpayment_order", "inpayment-order");
    this.addIcon("password", "password");
    this.addIcon("email", "email");
    this.addIcon("phone", "phone");
    this.addIcon("user", "user");
    this.addIcon("gender", "gender");
    this.addIcon("age", "age");
    this.addIcon("flag", "flag");
    this.addIcon('ticket_type_white', "ticket-type-white");
    this.addIcon("people", "people");
    this.addIcon("status", "status");
    this.addIcon("book_online", "book_online");
    this.addIcon("clear", "clear");
    this.addIcon("slash", "slash");
    this.addIcon("tickets", "tickets");
    this.addIcon("dates", "dates");
    this.addIcon("increase", "increase");
    this.addIcon("minus", "minus");
    this.addIcon("back", "back");
    this.addIcon("next", "next");
    this.addIcon("verify_email", "verify_email");
    this.addIcon("nationality", "nationality");
    this.addIcon("confirmation", "confirmation");
    this.addIcon("visitor-info", "visitor-info");
    this.addIcon("add_email", "add_email");
    this.addIcon("mail", "mail");
    this.addIcon("change", "change");
    this.addIcon("arrow-key", "arrow-key");
    this.addIcon("arrow-back", "arrow-back");
    this.addIcon("card", "card");
    this.addIcon("visa", "visa");
    this.addIcon("master", "master");
    this.addIcon("union", "union");
    this.addIcon("jcb", "jcb");
    this.addIcon("khqr", "khqr");
    this.addIcon("aba-pay", "aba-pay");
    this.addIcon("acleda-pay", "acleda-pay");
    this.addIcon("american", "american", "png");
    this.addIcon("diners-club", "diners-club", "png");
    this.addIcon("discover", "discover", "png");
    this.addIcon("checkout_cross", "checkout_cross");
    this.addIcon("next_arrow", "next_arrow");
  }
  private addIcon(name: string, filename: string, extension: 'svg' | 'png' = 'svg'): void {
    try {
      const url = `${this.iconPath}${filename}.${extension}`;
      this.icon.addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(url));
    } catch (err) {
      console.warn(`Failed to register icon ${name}`, err);
    }
  }

  prepareRoute(outlet: RouterOutlet): string {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }
}
